import * as actionTypes from "./ActionTypes"


export function setLoading(visible,text) {
    return {
        type: actionTypes.SET_LOADING,
        payload: {visible:visible, text:text}
    }
}
